import { Configuration } from '@sharefiledev/sharing-pilet-sdk/api';

export const permissionHttpConfiguration = new Configuration({
	basePath: `${window.origin}/io/permissions/v1`,
});
export function configureHttp(configure: (current: Configuration) => void) {
	configure(permissionHttpConfiguration);
}
